/**
 * Configuration constants for tag family grouping
 */
export const TAG_GROUPING_CONFIG = {
  /** Maximum number of tags before grouping into families */
  MAX_TAGS_BEFORE_GROUPING: 7,
  /** Family identifier suffix in tag slugs */
  FAMILY_SUFFIX: '-family',
  /** Special family tag for legacy products */
  LEGACY_PRODUCTS_SLUG: 'old-products',
} as const;
